@if (isAdmin$ | async) {
  <svg
    version="1.1"
    id="Layer_2"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    attr.height="{{ logoHeight }}px"
    attr.width="{{ logoWidth }}px"
    x="0px"
    y="0px"
    viewBox="0 0 153.776 78.591"
    style="enable-background: new 0 0 153.776 78.591"
    xml:space="preserve"
    >
    <style type="text/css">
      .st0 {
      fill: url(#SVGID_1_);
    }
    .st1 {
    fill: #575d60;
  }
  .st2 {
  fill: #ffffff;
}
</style>
<g>
  <linearGradient
    id="SVGID_1_"
    gradientUnits="userSpaceOnUse"
    x1="28.0228"
    y1="58.9987"
    x2="50.7743"
    y2="19.5919"
    >
    <stop offset="0" style="stop-color: #329cc5" />
    <stop offset="0.0927" style="stop-color: #349dc1" />
    <stop offset="0.2247" style="stop-color: #379eb7" />
    <stop offset="0.3804" style="stop-color: #3da1a5" />
    <stop offset="0.5542" style="stop-color: #46a68b" />
    <stop offset="0.7429" style="stop-color: #51ac68" />
    <stop offset="0.9412" style="stop-color: #5eb43a" />
    <stop offset="1" style="stop-color: #63b72b" />
  </linearGradient>
  <path
    class="st0"
            d="M39.399,62.043L39.399,62.043c-12.563,0-22.748-10.184-22.748-22.748v0c0-12.563,10.184-22.748,22.748-22.748
         h0c12.563,0,22.748,10.184,22.748,22.748v0C62.146,51.858,51.962,62.043,39.399,62.043z"
    />
    <g>
      <polygon
        class="st1"
               points="90.244,45.023 76.784,26.631 72.442,26.631 72.442,51.959 76.639,51.959 76.639,33.352 
            90.244,51.959 94.441,51.959 94.441,26.631 90.244,26.631 		"
        />
        <path
          class="st1"
               d="M111.798,28.242c-1.918-1.073-4.12-1.61-6.604-1.61h-3.763h-1.484h-2.714v25.328h2.714h1.484h3.763
            c2.509,0,4.722-0.543,6.639-1.628c1.917-1.085,3.42-2.581,4.505-4.487c1.085-1.905,1.628-4.088,1.628-6.549
            c0-2.485-0.549-4.68-1.647-6.586C115.222,30.804,113.715,29.315,111.798,28.242z M113.046,42.733
            c-0.434,1.062-1.038,1.99-1.81,2.786c-0.772,0.796-1.676,1.417-2.714,1.864c-1.037,0.446-2.147,0.669-3.328,0.669h-3.763V30.539
            h3.763c1.182,0,2.291,0.223,3.328,0.669c1.037,0.447,1.942,1.068,2.714,1.864c0.772,0.796,1.375,1.725,1.81,2.786
            c0.433,1.062,0.651,2.207,0.651,3.438C113.696,40.526,113.479,41.671,113.046,42.733z"
          />
          <polygon
            class="st1"
               points="137.125,26.631 117.369,26.631 117.369,30.467 125.148,30.467 125.148,51.959 129.345,51.959 
            129.345,30.467 137.125,30.467 		"
            />
          </g>
          <path
            class="st2"
            d="M44.848,43.674c-1.086-1.084-2.853-1.086-3.939,0l-0.783,0.781c-0.753,0.755-2.07,0.755-2.823,0L34.21,41.36
         c-0.778-0.778-0.778-2.045,0-2.824l0.781-0.782c0.527-0.526,0.817-1.225,0.817-1.969c0-0.744-0.29-1.443-0.816-1.969l-1.444-1.444
         c-1.053-1.052-2.887-1.053-3.94,0.001c-1.628,1.628-2.524,3.792-2.524,6.094c0,2.302,0.896,4.467,2.524,6.095l4.493,4.494
         c1.628,1.628,3.792,2.525,6.095,2.525c2.302-0.001,4.468-0.897,6.096-2.525c1.086-1.086,1.086-2.853,0-3.939L44.848,43.674z
          M45.357,48.123c-1.378,1.379-3.211,2.138-5.161,2.138s-3.783-0.759-5.161-2.138l-4.493-4.494c-1.38-1.379-2.138-3.212-2.138-5.162
         s0.759-3.783,2.138-5.162c0.276-0.277,0.644-0.429,1.035-0.429c0.392,0,0.76,0.153,1.036,0.429l1.445,1.444
         c0.276,0.277,0.429,0.644,0.429,1.036c0,0.392-0.153,0.759-0.43,1.036l-0.782,0.782c-1.293,1.293-1.293,3.397,0,4.69l3.094,3.094
         c1.254,1.253,3.439,1.253,4.69,0l0.783-0.781c0.569-0.571,1.498-0.572,2.071,0l1.444,1.444c0.277,0.277,0.43,0.645,0.43,1.036
         S45.634,47.846,45.357,48.123z M39.073,38.084c-0.018-0.489,0.158-0.954,0.491-1.312c0.689-0.736,1.848-0.776,2.586-0.088
         c0.737,0.688,0.776,1.848,0.089,2.585c-0.334,0.358-0.788,0.564-1.276,0.58c-0.021,0.001-0.042,0.001-0.063,0.001
         c-0.465,0-0.906-0.174-1.247-0.493C39.296,39.025,39.09,38.572,39.073,38.084z M50.815,39.423c-0.046,0.33-0.329,0.568-0.653,0.568
         c-0.031,0-0.062-0.002-0.093-0.006c-0.361-0.051-0.612-0.385-0.562-0.745c0.396-2.812-0.602-5.644-2.668-7.575
         c-2.068-1.932-4.966-2.735-7.739-2.148c-0.362,0.07-0.706-0.153-0.782-0.51c-0.075-0.357,0.153-0.707,0.509-0.782
         c3.205-0.673,6.533,0.252,8.913,2.476C50.121,32.925,51.27,36.185,50.815,39.423z M45.462,38.668
         c0.209-1.491-0.32-2.993-1.415-4.015s-2.628-1.449-4.101-1.137c-0.357,0.071-0.707-0.153-0.782-0.51
         c-0.075-0.357,0.153-0.707,0.509-0.782c1.898-0.398,3.867,0.15,5.274,1.465c1.408,1.315,2.089,3.245,1.821,5.162
         c-0.046,0.33-0.329,0.569-0.653,0.569c-0.031,0-0.062-0.002-0.093-0.006C45.663,39.362,45.411,39.029,45.462,38.668z"
            />
          </g>
        </svg>
      } @else {
        <svg
          version="1.1"
          id="Layer_2"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          attr.height="{{ logoHeight }}px"
          attr.width="{{ logoWidth }}px"
          x="0px"
          y="0px"
          viewBox="0 0 153.776 78.591"
          style="enable-background: new 0 0 153.776 78.591"
          xml:space="preserve"
          >
          <style type="text/css">
            .st0 {
            fill: #0099dc;
          }
          .st1 {
          fill: #575d60;
        }
        .st2 {
        fill: #ffffff;
      }
    </style>
    <g>
      <path
        class="st0"
            d="M39.399,62.043L39.399,62.043c-12.563,0-22.748-10.184-22.748-22.748v0c0-12.563,10.184-22.748,22.748-22.748
		h0c12.563,0,22.748,10.184,22.748,22.748v0C62.146,51.858,51.962,62.043,39.399,62.043z"
        />
        <g>
          <polygon
            class="st1"
               points="90.244,45.023 76.784,26.631 72.442,26.631 72.442,51.959 76.639,51.959 76.639,33.352 
			90.244,51.959 94.441,51.959 94.441,26.631 90.244,26.631 		"
            />
            <path
              class="st1"
               d="M111.798,28.242c-1.918-1.073-4.12-1.61-6.604-1.61h-3.763h-1.484h-2.714v25.328h2.714h1.484h3.763
			c2.509,0,4.722-0.543,6.639-1.628c1.917-1.085,3.42-2.581,4.505-4.487c1.085-1.905,1.628-4.088,1.628-6.549
			c0-2.485-0.549-4.68-1.647-6.586C115.222,30.804,113.715,29.315,111.798,28.242z M113.046,42.733
			c-0.434,1.062-1.038,1.99-1.81,2.786c-0.772,0.796-1.676,1.417-2.714,1.864c-1.037,0.446-2.147,0.669-3.328,0.669h-3.763V30.539
			h3.763c1.182,0,2.291,0.223,3.328,0.669c1.037,0.447,1.942,1.068,2.714,1.864c0.772,0.796,1.375,1.725,1.81,2.786
			c0.433,1.062,0.651,2.207,0.651,3.438C113.696,40.526,113.479,41.671,113.046,42.733z"
              />
              <polygon
                class="st1"
               points="137.125,26.631 117.369,26.631 117.369,30.467 125.148,30.467 125.148,51.959 129.345,51.959 
			129.345,30.467 137.125,30.467 		"
                />
              </g>
              <path
                class="st2"
            d="M44.848,43.674c-1.086-1.084-2.853-1.086-3.939,0l-0.783,0.781c-0.753,0.755-2.07,0.755-2.823,0L34.21,41.36
		c-0.778-0.778-0.778-2.045,0-2.824l0.781-0.782c0.527-0.526,0.817-1.225,0.817-1.969c0-0.744-0.29-1.443-0.816-1.969l-1.444-1.444
		c-1.053-1.052-2.887-1.053-3.94,0.001c-1.628,1.628-2.524,3.792-2.524,6.094c0,2.302,0.896,4.467,2.524,6.095l4.493,4.494
		c1.628,1.628,3.792,2.525,6.095,2.525c2.302-0.001,4.468-0.897,6.096-2.525c1.086-1.086,1.086-2.853,0-3.939L44.848,43.674z
		 M45.357,48.123c-1.378,1.379-3.211,2.138-5.161,2.138s-3.783-0.759-5.161-2.138l-4.493-4.494c-1.38-1.379-2.138-3.212-2.138-5.162
		s0.759-3.783,2.138-5.162c0.276-0.277,0.644-0.429,1.035-0.429c0.392,0,0.76,0.153,1.036,0.429l1.445,1.444
		c0.276,0.277,0.429,0.644,0.429,1.036c0,0.392-0.153,0.759-0.43,1.036l-0.782,0.782c-1.293,1.293-1.293,3.397,0,4.69l3.094,3.094
		c1.254,1.253,3.439,1.253,4.69,0l0.783-0.781c0.569-0.571,1.498-0.572,2.071,0l1.444,1.444c0.277,0.277,0.43,0.645,0.43,1.036
		S45.634,47.846,45.357,48.123z M39.073,38.084c-0.018-0.489,0.158-0.954,0.491-1.312c0.689-0.736,1.848-0.776,2.586-0.088
		c0.737,0.688,0.776,1.848,0.089,2.585c-0.334,0.358-0.788,0.564-1.276,0.58c-0.021,0.001-0.042,0.001-0.063,0.001
		c-0.465,0-0.906-0.174-1.247-0.493C39.296,39.025,39.09,38.572,39.073,38.084z M50.815,39.423c-0.046,0.33-0.329,0.568-0.653,0.568
		c-0.031,0-0.062-0.002-0.093-0.006c-0.361-0.051-0.612-0.385-0.562-0.745c0.396-2.812-0.602-5.644-2.668-7.575
		c-2.068-1.932-4.966-2.735-7.739-2.148c-0.362,0.07-0.706-0.153-0.782-0.51c-0.075-0.357,0.153-0.707,0.509-0.782
		c3.205-0.673,6.533,0.252,8.913,2.476C50.121,32.925,51.27,36.185,50.815,39.423z M45.462,38.668
		c0.209-1.491-0.32-2.993-1.415-4.015s-2.628-1.449-4.101-1.137c-0.357,0.071-0.707-0.153-0.782-0.51
		c-0.075-0.357,0.153-0.707,0.509-0.782c1.898-0.398,3.867,0.15,5.274,1.465c1.408,1.315,2.089,3.245,1.821,5.162
		c-0.046,0.33-0.329,0.569-0.653,0.569c-0.031,0-0.062-0.002-0.093-0.006C45.663,39.362,45.411,39.029,45.462,38.668z"
                />
              </g>
            </svg>
          }
